import { createFileRoute } from "@tanstack/react-router";

import { SessionPage } from "@/components/session/SessionPage";
import { currentUserQueryOptions } from "@/hooks/current-user";

export const Route = createFileRoute("/_authed/_chrome/session")({
  // Prefetch into the Query cache so the page arrives server-rendered with
  // real data; SessionPage reads it back via useSuspenseQuery.
  loader: ({ context }) => context.queryClient.ensureQueryData(currentUserQueryOptions()),
  head: () => ({ meta: [{ title: "Session" }] }),
  component: SessionPage,
});
